export enum ExperimentVariant {
    VARIANT_A = 'A',
    VARIANT_B = 'B',
    VARIANT_C = 'C',
    VARIANT_D = 'D',
}

export const GrowthBookFeature = {
    REVIEW_FEATURE_FLAG: 'GTC-2380',
    UNREAD_FEATURE_FLAG: 'GTC-2379',
    FORGOTTEN_PASSWORD_FLAG: 'GTC-2643',
    LOGOUT_TO_BFF: 'GTCON-20',
    EXPIRED_ADS_BANNER: 'GTS-74',
    MCUFEED_CTA_CHANGE: 'GTCON-91',
    DATE_OF_BIRTH_INPUT: 'GTCON-42',
    HIDE_SMS: 'GTCON-274',
    NEW_FEATURES_COPY: 'GTS-142',
    LISTING_CAP_MODAL: 'GTS-105',
    REVEAL_NUMBER_LABEL: 'GTCON-331',
    POSTCODE_INPUT: 'GTCON-275',
    GOOGLE_REVIEW_SRP: 'google-review-srp',
    THANK_2_YOU: 'post-upsell-thank-2-you',
    GBG_VERIFY: 'gbg-verify',
    // sug search
    SUG_WITHOUT_CATEGORY: 'sug_without_category',
    BLOCKTHROUGH_JS: 'blockthrough-ad-script',
    SERVICE_NEW_UI: 'service-new-ui',
    PRE_AD_SOURCE: 'pre-ad-source',
    PREBID_TIMEOUT: 'prebid-timeout',
    ADSENCE_ADMARKETPLACE: 'adsence-admarketplace',
    CARMONEY_MONTHLY_PRICE: 'carmoney-monthly-price',
    CARMONEY_ABOVE_MAP: 'carmoney-above-map',
    CARMONEY_MONTHLY_PRICE_SRP: 'carmoney-monthly-price-srp',
    SOVRN_SWITCH_DURATION: 'sovrn-switch-duration',
    // vip phone number required
    VIP_CLICK_PHONE_NUMBER_REQUIRED: 'vip_click_phone_number_required',
    // motors cta optimization
    MOTORS_CTA_OPT: 'motors-cta-opt',
    MOTORS_POST_CALL_ENCOURAGE: 'motors-post-call-encourage',
    MOTORS_OUT_OF_CORE_HOUR: 'motors-out-of-core-hour',
    // for sale listing caps
    FOR_SALE_SELLER_TYPE_BUYER: 'Listing-Caps-Seller-Type-Buyer',
    // bark layout optimization
    BARK_LAYOUT_OPTIMIZATION: 'Bark-Layout-Optimization',
    // repurpose urgent revenue
    REPURPOSE_URGENT_REVENUE: 'Repurpose-Urgent-Revenue',
    FEATURE_AD_OPTIMISATION: 'feature-ad-optimisation',
    NEARBY_LISTING_NEW_ADS: 'nearby-listing-new-ads',
    CONSENT_BANNER_NEW_DESIGN: 'consent-banner-new-design',
} as const;

export const GrowthBookServerSideFeatures = {
    PHONE_MODEL: 'srp_filter_mobile_apple_samsung_model',
    PHONE_MODEL_A: 'srp_filter_mobile_model_google_xiaomi_huawei',
    KEYWORD_CORRECTION: 'GTF-2399',
    SYI_AI_POST: 'syi-ai-post',
    SUG_USE_NEW_RANK: 'sug_use_new_rank',
    SUG_USE_NEW_INDEX: 'sug_use_new_index',
    SUG_ALL_PLATFORM_ALIGN: 'sug_all_platform_align',
    SEO_BROWSE_LINK: 'seo-browse-related-link',
    GEO_OUTSIDE_SEARCH_RADIUS: 'geo_outside_search_radius',
    GEO_ZIPCODE_RADIUS: 'geo_zipcode_radius',
    SRP_ENTITY_RANK: 'srp_entity_rank',
    SRP_ENTITY_RECALL: 'srp_entity_recall',
    MULTIPLE_SELECT_FOR_SALE: 'for-sale-multiple-select',
    SRP_FILTER_P9: 'srp_filter_p9',
    SRP_FILTER_P11: 'srp_filter_p11',
    SRP_FILTER_FASHION: 'srp_filter_fashion_condition_colour_material_size',
    SEO_VIP_TOP_SEARCH: 'seo-add-vip-link',
    SRP_VIP_RANK: 'srp_vip_rank',
    SRP_VIP_RECALL: 'srp_vip_recall',
    SRP_RANK_PHASE2: 'srp_rank_phase2',
    SRP_RECALL_PHASE2: 'srp_recall_phase2',
    REMOVE_TOP_SEARCH: 'seo-remove-top-search',
    // bark synonym search
    BARK_SYNONYM_SEARCH: 'Bark-Synonym-Search',
    BK_TOC_EXP: 'Bk-ToC-Exp',
} as const;
